module.exports = __webpack_public_path__ + "img/BUSD.c328012c.svg";